/** @jsx jsx */
import { Card, Container, Grid, Heading, Paragraph } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { IContract } from "@/data/contracts";

interface ContractDetailsProps {
  contract: IContract;
}

export const ContractDetails: FC<ContractDetailsProps> = ({ contract }) => {
  const { t } = useTranslation("session");

  return (
    <Container>
      <Card sx={{ p: "md" }}>
        <Heading size="h-md">{t("CONTRACTS.DETAILS.TITLE")}</Heading>
        <Grid columns={["1fr", null, "1fr 1fr"]} gap="sm" sx={{ mt: "sm" }}>
          <InfoField label={t("CONTRACTS.DETAILS.PROJECT_NAME")} value={contract.projectName} />
          <InfoField label={t("CONTRACTS.DETAILS.PROJECT_ID")} value={contract.projectId} />
          <InfoField label={t("CONTRACTS.DETAILS.PROJECT_START_DATE")} value={contract.projectStartDate} />
          <InfoField label={t("CONTRACTS.DETAILS.PROJECT_END_DATE")} value={contract.projectEndDate} />
          <InfoField label={t("CONTRACTS.DETAILS.SUPPLIER_CONTRACT_ID")} value={contract.supplierContractId} />
          <InfoField label={t("CONTRACTS.DETAILS.CLIENT_NAME")} value={contract.clientName} />
          <InfoField label={t("CONTRACTS.DETAILS.CONSULTANT_NAME")} value={contract.consultantName} />
          <InfoField label={t("CONTRACTS.DETAILS.CONSULTANT_EMAIL")} value={contract.consultantEmail} />
          <InfoField label={t("CONTRACTS.DETAILS.TIME_REPORTER_NAME")} value={contract.timeReporterName} />
          <InfoField label={t("CONTRACTS.DETAILS.TIME_REPORTER_EMAIL")} value={contract.timeReporterEmail} />
          <InfoField label={t("CONTRACTS.DETAILS.SUPPLIER_CONTACT_NAME")} value={contract.supplierContactName} />
          <InfoField label={t("CONTRACTS.DETAILS.SUPPLIER_CONTACT_EMAIL")} value={contract.supplierContactEmail} />
        </Grid>
      </Card>
    </Container>
  );
};

const InfoField: FC<{ label: string; value: string | number }> = ({ label, value }) => (
  <Grid columns={["1fr", "1fr 2fr"]} sx={{ alignItems: "center" }}>
    <Paragraph color="n700">{label}:</Paragraph>
    <Paragraph>{value || "N/A"}</Paragraph>
  </Grid>
);
